import React from 'react';
import Linkify from 'linkify-react';
import { Message as MessageType } from '@/widget/domain/message';
import cx from 'classnames';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import Attachment from './Attachment';
import styles from './Message.module.scss';

interface Props {
  message: MessageType
}
function Message({ message }: Props) {
  const { settings } = useChatWidgetContext();
  const {
    color: backgroundColor,
    textColor: color,
  } = settings;
  const htmlSafeText = message.text.replaceAll('<br>', '\n');

  return (
    <>
      <div className={cx(styles.container, { [styles.fromOperator]: message.fromOperator })}>
        {message.text && (
          <div
            style={{ backgroundColor, color: message.fromOperator ? '#343440' : color }}
            className={cx(styles.message, { [styles.operatorMessage]: message.fromOperator })}
          >
            <div className={styles.text}>
              <Linkify options={{ target: '_blank' }}>{htmlSafeText}</Linkify>
            </div>
          </div>
        )}
      </div>
      {message?.attachments?.map((attach) => (
        <div key={attach.id} className={cx(styles.container, { [styles.fromOperator]: message.fromOperator })}>
          <div
            style={{ backgroundColor, color }}
            className={cx(styles.attach, { [styles.operatorMessage]: message.fromOperator })}
          >
            <Attachment attachment={attach} />
          </div>
        </div>
      ))}
    </>
  );
}

export default Message;
